import { shipwreck } from '../../../components/shared/vector-images';
import { toggleLayerIfRequired } from '../_helpers';

const layer = {
  displayName: 'Shipwrecks',
  synonyms: '',
  group: 'mapboxLayer',
  typeUrl: 'shipwreck',
  icon: {
    baseShape: shipwreck,
    iconColor: '#fff',
    markerColor: '#E28D18',
  },
  shownByDefault: true,
  relativeDepth: 100,
  menuOptions: {
    visible: true,
    owningMenu: 'safety',
    order: 1000,
  },
};

layer.onInitialize = (/* map */) => {
  /* noop */
};

layer.onToggle = (map, show) => {
  toggleLayerIfRequired(map, 'shipwreck line', show);
  toggleLayerIfRequired(map, 'shipwreck fill', show);
  toggleLayerIfRequired(map, 'shipwreck symbol', show);
};

export default layer;
